/**
 * The tooltip bubble's look, shared by `Tooltip` and `TooltipBubble`. Kept out of the barrel so styling isn't public API.
 * w-max: size to the label. max-w keeps very long copy readable without forcing mid-length action labels (e.g.
 * reconcile tooltips at body-200 / 16px) to wrap early and leave empty space — CSS cannot shrink-wrap after a soft wrap.
 */
export const TOOLTIP_BUBBLE_CLASS_NAMES =
  'body-200-light w-max max-w-[min(90vw,24rem)] rounded-sm bg-neutral-1000 p-3 text-white shadow-lg';
